import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../components/default/login/service/login-service/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    // Redirect to login page if not authenticated
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // If user is an admin, redirect them to admin dashboard (admins should only access admin modules)
  if (authService.hasRole('Admin')) {
    router.navigate(['/admin/dashboard']);
    return false;
  }

  //  if (authService.hasRole('Doctor')) {
  //   console.log('Redirecting doctor user to dashboard');
  //   router.navigate(['/dashboard']);
  //   return false;
  // }


  // Regular users can access regular routes
  return true;
};

export const adminGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Check if user is authenticated
  if (!authService.isAuthenticated()) {
    // Redirect to admin login page
    router.navigate(['/admin/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  // Check if user has Admin role
  if (!authService.hasRole('Admin')) {
    // User is logged in but not an admin, redirect to regular dashboard
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};

export const loginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If already authenticated, redirect based on user role
  if (authService.isAuthenticated()) {
    if (authService.hasRole('Admin')) {
      // Admin users can choose - default to admin dashboard
      router.navigate(['/admin/dashboard']);
    } else {
      // Regular users go to regular dashboard
      router.navigate(['/dashboard']);
    }
    return false;
  }

  return true;
};

export const adminLoginGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If already authenticated as admin, redirect to admin dashboard
  if (authService.isAuthenticated() && authService.hasRole('Admin')) {
    router.navigate(['/admin/dashboard']);
    return false;
  }

  return true;
};
